import React, { useMemo } from 'react';
import { createFloatingParticles } from '../../utils/createFloatingParticles';
import './SeasonalEffect.css';
import './WinterSnow.css';

const FLAKE_COUNT = 30;
const MOBILE_FLAKE_COUNT = 15;

function SnowflakeCrystal({ variant = 0 }) {
  const branch =
    variant === 1 ? (
      <>
        <line x1="0" y1="0" x2="0" y2="-9" />
        <line x1="0" y1="-4.5" x2="-2.2" y2="-6.2" />
        <line x1="0" y1="-4.5" x2="2.2" y2="-6.2" />
        <line x1="0" y1="-7" x2="-1.6" y2="-8.2" />
        <line x1="0" y1="-7" x2="1.6" y2="-8.2" />
      </>
    ) : variant === 2 ? (
      <>
        <line x1="0" y1="0" x2="0" y2="-9" />
        <line x1="0" y1="-3.5" x2="-2.5" y2="-5.5" />
        <line x1="0" y1="-3.5" x2="2.5" y2="-5.5" />
        <line x1="0" y1="-6.5" x2="-1.8" y2="-8" />
        <line x1="0" y1="-6.5" x2="1.8" y2="-8" />
        <line x1="0" y1="-8.5" x2="-1.2" y2="-9.5" />
        <line x1="0" y1="-8.5" x2="1.2" y2="-9.5" />
      </>
    ) : (
      <>
        <line x1="0" y1="0" x2="0" y2="-9" />
        <line x1="0" y1="-4" x2="-2" y2="-6" />
        <line x1="0" y1="-4" x2="2" y2="-6" />
        <line x1="0" y1="-6.5" x2="-1.5" y2="-7.8" />
        <line x1="0" y1="-6.5" x2="1.5" y2="-7.8" />
        <circle cx="0" cy="-9" r="0.8" fill="currentColor" stroke="none" />
      </>
    );

  return (
    <svg
      className="snowflake-crystal"
      viewBox="-12 -12 24 24"
      aria-hidden="true"
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {[0, 60, 120, 180, 240, 300].map((angle) => (
          <g key={angle} transform={`rotate(${angle})`}>
            {branch}
          </g>
        ))}
      </g>
    </svg>
  );
}

function WinterSnow() {
  const flakes = useMemo(
    () =>
      createFloatingParticles(FLAKE_COUNT, {
        sizeMin: 10,
        sizeRange: 12,
        startXMin: 0,
        startXRange: 100,
        driftMin: -8,
        driftRange: 16,
        durationMin: 12,
        durationRange: 10,
        spinMin: 0,
        spinRange: 180,
        opacityMin: 0.5,
        opacityRange: 0.35,
      }),
    []
  );

  return (
    <div className="seasonal-effect winter-snow" aria-hidden="true">
      {flakes.map((flake, index) => (
        <span
          key={flake.id}
          className={`seasonal-particle snowflake${index >= MOBILE_FLAKE_COUNT ? ' seasonal-particle--desktop' : ''}`}
          style={{
            '--particle-size': `${flake.size}px`,
            '--particle-ratio': 1,
            '--start-x': `${flake.startX}%`,
            '--delay': `${flake.delay}s`,
            '--duration': `${flake.duration}s`,
            '--drift': `${flake.drift}vw`,
            '--spin': `${flake.spin}deg`,
            '--particle-opacity': flake.opacity,
          }}
        >
          <SnowflakeCrystal variant={flake.id % 3} />
        </span>
      ))}
    </div>
  );
}

export default WinterSnow;
